import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

export default function ConfirmDialog({ open, setOpen, callBack }) {
  return (
    <Dialog open={open}>
      <DialogTitle style={{ backgroundColor: "#FF4D21" }}>
        <Typography variant={"h3"}>Emergency withdraw</Typography>
      </DialogTitle>
      <DialogContent style={{ backgroundColor: "#000422" }}>
        <DialogContentText>
          <Typography variant={"subtitle1"} style={{ marginTop: 8 }}>
            Emergency withdraw is an extreme function in case of farm critical errors
            and calling it will withdraw your staked token but it will
            <b> forfeit your pending rewards</b>. All your staked amounts will be
            withdrawn even the locked stakes (No Penalty will be applied)
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#000422" }}>
        <Button onClick={callBack} style={{ color: "#F0D500" }}>
          Yes forfeit My Rewards
        </Button>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export function DisclaimerDialog({ open, setOpen, callBack }) {
  return (
    <Dialog open={open}>
      <DialogContent style={{ backgroundColor: "#160B0B" }}>
        <DialogContentText>
          <Alert severity={"error"}>
            <ol style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <Typography variant={"h3"}>Corsac V2 Staking Disclaimer</Typography>
              <Typography variant={"body2"}>
                Staking your Corsac V2 tokens in the staking pool implies that you
                have understood the following:
              </Typography>
              <li>
                Upon staking 15% of staked tokens will be deducted as tax. This is at
                par with Corsac V2 tokenomics. In other words, whatever you stake,
                15% less of that will get staked, as those will be distrubted as 9%
                BUSD Rewards to holders, 4% to marketing wallet and 2% will be added
                to liquidty pool.
              </li>
              <li>
                The APY is self adjusting. This means the more people gets into the
                staking pool, the lesser the APY will become. Corsac V2 Authorities
                shall not be responsible for fall in APY due to high number of
                staking resulting in failure of recovery of even the taxed amount of
                staking. So it is advisable to calculate the probable returns before
                hand and understand the probable risks of return.
              </li>
              <li>
                Staked tokens are not eligible for BUSD Rewrads, as they are not
                stored in your wallet.
              </li>
              <li>
                There’s a lock in period for 30 days. Premature un-staking will
                result in 10% tax as penalty.
              </li>
              <li>
                You can manually harvest the reward generated, however you will have
                to pay for the gas fee which is levied by Binance Smart Chain.
              </li>
              <li>No tax is there for unstaking after the locked period is over.</li>
              <li>
                After 30 days, your tokens will be excluded from getting the rewards
                of staking. You have to unstake and then restake freshly to earn
                staking rewards.
              </li>
            </ol>
            <p style={{ width: "100%", textAlign: "right", marginTop: 12 }}>
              Regards, Corsac Development Team
            </p>
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#160B0B" }}>
        <Button onClick={callBack} style={{ color: "#15C39A" }}>
          I Understand
        </Button>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
